<template>
  <LsModal title="Discount Price" track-id="turn_down_quote_modal_backup">
    <template #body>
      <div class="columns">
        <div class="column">
          <p class="turn-down-quote-modal-backup--text">
            We want to make sure you have a great experience so we are willing to discount the
            service to
            <strong test-id="turn_down_quote_modal_backup-backup_price">{{ backupAmount }}</strong
            >.<br /><br />
            Would you like to accept the service on <strong>{{ serviceDate | date }}</strong> at
            <strong>{{ backupAmount }}</strong
            >?
          </p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="turn-down-quote-modal-backup--button-wrapper">
        <LsButton
          class="turn-down-quote-modal-backup--button"
          text="no"
          bg-color="primary-light"
          text-color="primary"
          track-id="turn_down_quote_modal_backup-turn_down"
          @click="next"
        />
        <LsButton
          class="turn-down-quote-modal-backup--button"
          :text="`accept quote for ${backupAmount}`"
          track-id="turn_down_quote_modal_backup-accept_discounted_price"
          :loading="schedules.loadingStatus.isUpdating"
          @click="approveQuote"
        />
      </div>
    </template>
  </LsModal>
</template>

<script>
import VueTypes from 'vue-types';
import { lsFilters } from 'ls-vue-common';
import { LsModal, LsButton } from '@/components/common';
import { mapState, mapActions } from 'vuex';
import { SCHEDULES__APPROVE_QUOTE } from '../../../store/types';

export default {
  name: 'TurnDownQuoteModalBackup',
  components: { LsModal, LsButton },
  props: {
    //eslint-disable-next-line vue/prop-name-casing
    schedule_id: VueTypes.number.isRequired,
    next: VueTypes.func.isRequired,
  },
  computed: {
    ...mapState(['schedules']),
    backupAmount() {
      const { amount_backup } = this.schedules.schedulesById[this.schedule_id].manualquote.price;

      return lsFilters.currency({
        amount: amount_backup,
      });
    },
    serviceDate() {
      const { next_starts_at } = this.schedules.schedulesById[this.schedule_id];

      return next_starts_at;
    },
  },
  methods: {
    ...mapActions([SCHEDULES__APPROVE_QUOTE]),
    async approveQuote() {
      await this[SCHEDULES__APPROVE_QUOTE]({ schedule_id: this.schedule_id, backup: true });
      this.$parent.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.turn-down-quote-modal-backup--text {
  height: 100px;
  padding-bottom: 10px;
}
.turn-down-quote-modal-backup--button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.turn-down-quote-modal-backup--button {
  margin: 4px;
}
</style>
